import type { ReactNode } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { RequireAuth } from "./components/RequireAuth";
import { useAuth } from "./hooks/useAuth";
import { Login } from "./pages/Login";
import { VisitNoteDetail } from "./pages/VisitNoteDetail";
import { VisitNoteNew } from "./pages/VisitNoteNew";
import { VisitNotesList } from "./pages/VisitNotesList";

function Shell({ children }: { children: ReactNode }) {
  const { user, signOutUser } = useAuth();

  return (
    <div className="shell">
      {user && (
        <nav className="shell-nav">
          <span>{user.displayName ?? user.email}</span>
          <button type="button" onClick={() => void signOutUser()}>
            Sign out
          </button>
        </nav>
      )}
      <main>{children}</main>
    </div>
  );
}

export function App() {
  return (
    <Shell>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <RequireAuth>
              <VisitNotesList />
            </RequireAuth>
          }
        />
        <Route
          path="/visit-notes/new"
          element={
            <RequireAuth>
              <VisitNoteNew />
            </RequireAuth>
          }
        />
        <Route
          path="/visit-notes/:id"
          element={
            <RequireAuth>
              <VisitNoteDetail />
            </RequireAuth>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Shell>
  );
}
